import { explosiveFeed } from '@/mocks/blackinfo';

export default function ExplosiveSection() {
  return (
    <section id="explosive" className="mx-auto max-w-[1280px] px-4 pt-12 md:px-6 md:pt-16">
      <div className="flex items-end justify-between border-b border-stone-200 pb-3">
        <div>
          <h2 className="flex items-center gap-2 font-display text-xl font-bold text-stone-950 md:text-2xl">
            <i className="ri-vip-crown-fill text-red-600" /> 猛料速报
          </h2>
          <p className="mt-1 text-xs text-stone-500 md:text-sm">完整复盘与关联起底类长料，信息量大，建议留出时间细读。</p>
        </div>
        <span className="hidden shrink-0 items-center gap-1 rounded-full border border-red-200 bg-red-50 px-3 py-1 text-xs font-semibold text-red-600 sm:inline-flex">
          共 3 组硬料
        </span>
      </div>

      <div className="mt-5 flex flex-col gap-5">
        {explosiveFeed.map((s) => (
          <a
            key={s.id}
            href="#timeline"
            className="group grid grid-cols-1 overflow-hidden rounded-lg border border-stone-200 bg-white transition-colors hover:border-stone-300 md:grid-cols-5"
          >
            {/* 封面 */}
            <div className="relative h-52 w-full md:col-span-3 md:h-64 lg:h-72">
              <img src={s.cover} alt={s.title} className="h-full w-full object-cover" />
              <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded bg-stone-950/80 px-2.5 py-1 text-xs font-bold text-white backdrop-blur">
                <i className="ri-vip-diamond-fill text-red-400" /> {s.tag}
              </span>
            </div>
            {/* 文案 */}
            <div className="flex flex-col p-5 md:col-span-2 md:p-6">
              <div className="flex items-center gap-2 text-[11px] text-stone-400">
                <span className="inline-flex items-center gap-1">
                  <i className="ri-time-line" /> {s.time}
                </span>
                <span className="h-3 w-px bg-stone-200" />
                <span className="inline-flex items-center gap-1">
                  <i className="ri-fire-line text-red-400" /> {s.read}
                </span>
              </div>
              <h3 className="mt-3 font-display text-lg font-bold leading-snug text-stone-900 group-hover:text-red-700 md:text-xl">
                {s.title}
              </h3>
              <p className="mt-2 line-clamp-3 text-xs leading-relaxed text-stone-500 md:text-sm">{s.summary}</p>
              <div className="mt-auto flex flex-wrap items-center justify-between gap-3 pt-4">
                <span className="rounded-full border border-stone-200 bg-stone-50 px-2.5 py-0.5 text-[11px] font-medium text-stone-600">
                  {s.status}
                </span>
                <span className="inline-flex items-center gap-1 text-sm font-medium text-red-600">
                  读完整复盘 <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" />
                </span>
              </div>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}